import { useState, useEffect, useCallback } from 'react';
import { Typography, Button, Grid, Paper, TextField, FormControl, Select, MenuItem } from '@mui/material';
import { useDispatch } from 'react-redux';
import QueryBuilder from '../../query-builder/QueryBuider';
import { getOfferConfig, getOfferSource, getOfferSourceTotalRecords, reviewOffer } from '../../../../services/OffersService';
import { offersActions } from '../../../../store/slices/offers';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import DateTimeInput from '../../../Utils/DateTimeInput/DateTimeInput';
import Loader from '../../../../assets/60-X-60_Loader.gif';
import { useNavigate } from 'react-router';
import { CommonLanguage, customoffer, createoffer } from '../../../../Language/language';
import ErrorPage from '../../../../ErrorPage';
import SegmentSourceError from '../../segments/SegmentSourceError';
import LoadingScreen from '../../LoadingScreen/LoadingScreen';
import { LoadingScreen6ForOffer } from '../../../../Language/DialogBoxLanguage';
import { getSegmentEditInfo } from '../../../../services/SegmentService';
import { useParams } from 'react-router-dom';

const { setCreateOfferInputFields, setOfferCreate, setOfferAction } = offersActions;

const CustomeCreateOffer = ({ setIsPageType }) => {
  const { sk, pk } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isFileMissingLoading, setIsFileMissingLoading] = useState(false);
  const [isLoadingReview, setIsLoadingReview] = useState(false);
  const [isLoadingTargateData, setIsLoadingTargateData] = useState(false);
  const [isDisplayTotalDataSet, setIsDisplayTotalDataSet] = useState(false);
  const { create, offerAction } = useSelector((state) => state.offers);
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => setShowModal(false);
  const [sourceModal, setsourceModal] = useState(false);
  const closeSource = () => setsourceModal(false);
  const [errormsg, seterrormsg] = useState();
  const locationstateData = location?.state?.data;

  const getEditInfo = async (type) => {
    const payload = {
      pk: `offer#${pk}`,
      sk: `offer#${sk}`,
      entity_type: 'offer',
      process_type: type === 'Edit' ? 'edit' : 'copy',
    };
    const responseData = await getSegmentEditInfo(payload);
    if (responseData.status === 200) {
      const newResponse = { ...responseData?.data };
      dispatch(setOfferCreate({ response: newResponse }));
      // dispatch(setEditSegmentInfo({ response: segmentData }));
      dispatch(setOfferAction(type));
      // navigate(`/edit-segment/${(segmentData.sk).split('#')[1]}/${(segmentData.pk).split('#')[1]}`);
    } else {
      seterrormsg(responseData?.response?.data?.error);
      setShowModal(true);
    }
  };

  const getOfferConfigData = async () => {
    const payload = {
      source: create.selectedOfferSource,
    };
    const responseData = await getOfferConfig(payload);
    if (responseData.status === 200) {
      const name = 'offerConfig';
      const value = create.offerConfig ? { ...responseData.data, ...create.offerConfig } : responseData.data;
      dispatch(setCreateOfferInputFields({ name, value }));
    } else {
      setShowModal(true);
      seterrormsg(responseData?.response?.data?.error);
      // window.alert('error while geting Offer source config');
    }
    setIsLoading(false);
  };

  useEffect(() => {
    const pathName = location.pathname;
    if (pathName.includes('/edit-offer/')) {
      getEditInfo('Edit');
    } else if (pathName.includes('/copy-offer/')) {
      getEditInfo('Copy');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const gettingOfferSource = useCallback(async () => {
    if (create.offerSourceList.length === 0) {
      const responseData = await getOfferSource();
      if (responseData.status === 200) {
        const name = 'offerSourceList';
        const value = responseData.data;
        dispatch(setCreateOfferInputFields({ name, value }));
      } else {
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [create]);

  useEffect(() => {
    gettingOfferSource();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (create.selectedOfferSource !== 'offerSource') getOfferConfigData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [create.selectedOfferSource]);

  const handleDescriptionChange = (event) => {
    const name = 'description';
    const value = event.target.value;
    dispatch(setCreateOfferInputFields({ name, value }));
  };

  const handleOfferNameChange = (event) => {
    const name = 'name';
    const value = event.target.value;
    dispatch(setCreateOfferInputFields({ name, value }));
  };

  const handleOfferSourceChange = (event) => {
    const name = 'selectedOfferSource';
    const value = event.target.value;
    setIsLoading(true);
    dispatch(setCreateOfferInputFields({ name, value }));
  };

  const handleDateTimeChange = (event) => {
    const name = 'dateTime';
    const value = event;
    dispatch(setCreateOfferInputFields({ name, value }));
  };

  const getProcessType = () => {
    let action = 'create';
    if (offerAction === 'Add') {
      action = 'create';
    }
    if (offerAction === 'Copy') {
      action = 'copy';
    }
    if (offerAction === 'Edit') {
      action = 'edit';
    }
    return action;
  };

  const handleReviewOffer = async (event) => {
    event.preventDefault();
    setIsLoadingReview(true);
    const processType = getProcessType();
    const payload = {
      json_where_condition: create.json_where_condition,
      where_condition: create.where_condition,
      sql_where_condition: create.sql_where_condition,
      source: create.selectedOfferSource,
      entity_type: 'offer',
      name: create.name,
      description: create.description,
      total_records: create.totalRecords,
      process_type: processType,
      dateTime: create.dateTime,
      pk: `offer#${pk}`,
      sk: `offer#${sk}`,
    };
    const responseData = await reviewOffer(payload);
    if (responseData.status === 200) {
      const newResponse = {
        ...responseData.data,
        offerSourceList: create.offerSourceList,
        selectedOfferSource: create.selectedOfferSource,
        offerConfig: create.offerConfig,
        totalRecords: responseData.data?.total_record,
        dateTime: create.dateTime,
      };
      dispatch(setOfferCreate({ response: newResponse }));
      navigate(`/review-offer/${(responseData?.data?.sk).split('#')[1]}/${(responseData?.data?.pk).split('#')[1]}`, {
        state: {
          data: {
            ...locationstateData,
          },
        },
      });
    } else {
      seterrormsg(responseData?.response?.data?.error);
      setShowModal(true);
      // window.alert('error while review offer data');
    }
    setIsLoadingReview(false);
  };

  const handleGetTargetData = async (event) => {
    setIsDisplayTotalDataSet(true);
    event.preventDefault();
    setIsLoadingTargateData(true);
    const payload = {
      where_condition: create.where_condition,
      sql_where_condition: create.sql_where_condition,
      source: create.selectedOfferSource,
      entity_type: 'offer',
    };
    const responseData = await getOfferSourceTotalRecords(payload);
    if (responseData.status === 200) {
      const name = 'totalRecords';
      const value = responseData.data;
      dispatch(setCreateOfferInputFields({ name, value }));
      setIsLoadingTargateData(false);
      setIsDisplayTotalDataSet(true);
    } else {
      setIsLoadingTargateData(false);
      seterrormsg(responseData?.response?.data?.error);
      setShowModal(true);
      // window.alert('error while geting Offer source total records');
    }
    setIsLoadingTargateData(false);
  };

  const handleBackToCreateAICrafted = () => {
    navigate('/offers');
  };
  // const readableExp = QbUtils.queryString(tree, config, true);
  const toTitleCase = (str) => {
    return str
      ?.split('_') // Split the string at each underscore
      ?.map((word) => word.toUpperCase()) // Capitalize the first letter of each word
      ?.join(' '); // Join the words back together with spaces
  };
  return (
    <>
      <Paper
        sx={{
          backgroundColor: '#ffffff',
          width: '100%',
          // height: '100%',
          borderRadius: '6px',
        }}
      >
        {isFileMissingLoading ? (
          <Grid container justifyContent="center" alignItems="center" alignContent="center" style={{ height: '100%' }}>
            <LoadingScreen gifType={6} loadingScreen6={LoadingScreen6ForOffer} />
          </Grid>
        ) : (
          <Grid container sx={{ p: 2 }} spacing={2}>
            <Grid item xs={12} md={12} sm={12} lg={12}>
              <Grid container justifyContent="flex-start">
                <Grid item>
                  <Typography
                    sx={{
                      color: '#414446',
                      fontFamily: 'IBM Plex Serif',
                      fontSize: '24px',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      lineHeight: '40px',
                    }}
                  >
                    {createoffer.headlineText2}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container justifyContent="flex-start" spacing={2} sx={{ p: 2 }}>
              <Grid item xs={12} md={12} sm={12} lg={12}>
                <Typography
                  sx={{
                    color: 'var(--Col-9, #8E0000)',
                    fontFamily: 'Roboto',
                    fontSize: '12px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: '151.188%',
                  }}
                >
                  {CommonLanguage.fieldrequiredText}
                </Typography>
              </Grid>
              <Grid item xs={12} md={12} sm={12} lg={12}>
                <Typography
                  sx={{
                    color: 'var(--Col-8, #000)',
                    fontFamily: 'Roboto',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    lineHeight: 'normal',
                    textTransform: 'capitalize',
                  }}
                >
                  {customoffer.headlineText1}
                </Typography>
              </Grid>
              <Grid item xs={12} md={12} sm={12} lg={12}>
                <form>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6} sm={6} lg={6} sx={{ mr: 1 }}>
                      <TextField
                        id="offerName"
                        disabled={offerAction === 'Add' || offerAction === 'Copy' ? false : true}
                        sx={{ opacity: offerAction === 'Add' || offerAction === 'Copy' ? 1 : 0.5 }}
                        type="text"
                        fullWidth
                        size="medium"
                        value={create.name}
                        placeholder="Enter Offer name"
                        onChange={handleOfferNameChange}
                      />
                    </Grid>

                    <Grid item xs={12} md={6} sm={6} lg={6} sx={{ mr: 1 }}>
                      <TextField
                        id="description"
                        type="text"
                        fullWidth
                        size="medium"
                        multiline
                        rows={4}
                        value={create.description}
                        placeholder="Breif description"
                        onChange={handleDescriptionChange}
                      />
                    </Grid>

                    <Grid item xs={12} md={12} sm={12} lg={12}>
                      <Typography
                        sx={{
                          color: 'var(--Col-8, #000)',
                          fontFamily: 'Roboto',
                          fontSize: '14px',
                          fontStyle: 'normal',
                          fontWeight: 600,
                          lineHeight: 'normal',
                          textTransform: 'capitalize',
                        }}
                      >
                        {customoffer.headlineText2}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={12} sm={12} lg={12}>
                      <Typography
                        sx={{
                          color: 'var(--col-6, #5D596C)',
                          fontFamily: 'Roboto',
                          fontSize: '14px',
                          fontStyle: 'normal',
                          fontWeight: 400,
                          lineHeight: '173.7%',
                          textTransform: 'capitalize',
                        }}
                      >
                        {customoffer.subTitle1}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={6} sm={6} lg={6}>
                      <FormControl fullWidth size="small">
                        <Select value={create.selectedOfferSource} onChange={handleOfferSourceChange} displayEmpty inputProps={{ 'aria-label': 'Without label' }}>
                          <MenuItem value="offerSource" disabled={true}>
                            Select Offer source
                          </MenuItem>
                          {Array.isArray(create.offerSourceList) &&
                            create.offerSourceList.length > 0 &&
                            create.offerSourceList.map((source) => <MenuItem value={source}>{`${toTitleCase(source)}`}</MenuItem>)}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6} sm={6} lg={6}></Grid>
                    {isLoading ? (
                      <Grid item xs={12} md={12} sm={12} lg={12}>
                        <img src={Loader} alt="Loading..." />
                      </Grid>
                    ) : (
                      create.selectedOfferSource !== 'offerSource' &&
                      Object.keys(create.offerConfig).length > 0 && (
                        <>
                          <Grid item xs={12} md={12} sm={12} lg={12}>
                            <Typography
                              sx={{
                                color: 'var(--Col-8, #000)',
                                fontFamily: 'Roboto',
                                fontSize: '14px',
                                fontStyle: 'normal',
                                fontWeight: 600,
                                lineHeight: 'normal',
                                textTransform: 'capitalize',
                              }}
                            >
                              Define Rules
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={12} sm={12} lg={12}>
                            <Typography
                              sx={{
                                color: 'var(--col-6, #5D596C)',
                                fontFamily: 'Roboto',
                                fontSize: '14px',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                lineHeight: '173.7%',
                                textTransform: 'capitalize',
                              }}
                            >
                              Specify conditions based on your selected criteria
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={7} sm={7} lg={7}>
                            <QueryBuilder queryConfig={create.offerConfig} json_where_condition={create.json_where_condition} setCreateInputFields={setCreateOfferInputFields} />
                          </Grid>

                          <Grid item xs={12} md={5} sm={5} lg={5}></Grid>
                        </>
                      )
                    )}

                    {isLoadingTargateData ? (
                      <Grid item xs={12} md={12} sm={12} lg={12}>
                        <img src={Loader} alt="Loading..." />
                      </Grid>
                    ) : (
                      <>
                        {isDisplayTotalDataSet && (
                          <>
                            <Grid item xs={12} md={12} sm={12} lg={12}>
                              <Typography
                                sx={{
                                  color: 'var(--Col-8, #000)',
                                  fontFamily: 'Roboto',
                                  fontSize: '18px',
                                  fontStyle: 'normal',
                                  fontWeight: 600,
                                  lineHeight: 'normal',
                                  textTransform: 'capitalize',
                                }}
                              >
                                {customoffer.headlineText3}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} md={12} sm={12} lg={12}>
                              <Typography
                                sx={{
                                  color: '#414446',
                                  fontFamily: 'IBM Plex Serif',
                                  fontSize: '24px',
                                  fontStyle: 'normal',
                                  fontWeight: 400,
                                  lineHeight: 'normal',
                                  textTransform: 'capitalize',
                                }}
                              >
                                {create.totalRecords}
                              </Typography>
                            </Grid>
                          </>
                        )}
                      </>
                    )}

                    <Grid item xs={12} md={12} sm={12} lg={12}>
                      <Typography
                        sx={{
                          color: 'var(--col-8, #000)',
                          fontFamily: 'Roboto',
                          fontSize: '18px',
                          fontStyle: 'normal',
                          fontWeight: 600,
                          lineHeight: 'normal',
                          textTransform: 'capitalize',
                        }}
                      >
                        {customoffer.headlineText4}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={12} sm={12} lg={12} sx={{ mt: 1 }}>
                      <DateTimeInput name="dateTime" onDateTimeChange={handleDateTimeChange} dateTimeData={create.dateTime} />
                    </Grid>

                    <Grid item xs={12} md={12} sm={12} lg={12}>
                      <Button
                        type="submit"
                        variant="contained"
                        disabled={!create.sql_where_condition}
                        sx={{
                          color: '#ffffff',
                          fontFamily: 'Roboto',
                          fontSize: '1rem',
                          marginTop: '15px',
                          fontWeight: 'Bold',
                          textAlign: 'center',
                          textTransform: 'capitalize',
                          width: { lg: '10rem', sm: '10rem' },
                          height: '48px',
                          borderRadius: '6px',
                          backgroundColor: '#852598',
                          ':hover': {
                            backgroundColor: '#852598',
                          },
                        }}
                        onClick={handleGetTargetData}
                      >
                        {customoffer.targetbtn}
                      </Button>

                      <Button
                        type="submit"
                        variant="contained"
                        disabled={!create.sql_where_condition}
                        sx={{
                          color: '#ffffff',
                          fontFamily: 'Roboto',
                          fontSize: '1rem',
                          marginTop: '15px',
                          fontWeight: 'Bold',
                          textAlign: 'center',
                          textTransform: 'capitalize',
                          width: { lg: '10rem', sm: '8rem' },
                          height: '48px',
                          borderRadius: '6px',
                          backgroundColor: '#852598',
                          ':hover': {
                            backgroundColor: '#852598',
                          },
                          ml: 2,
                          mr: 2,
                        }}
                        onClick={handleReviewOffer}
                      >
                        {customoffer.reviewbtn}
                      </Button>

                      {isLoadingReview && (
                        <div
                          style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100vh',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            zIndex: 99,
                          }}
                        >
                          <LoadingScreen gifType={4} />
                        </div>
                      )}

                      <Button
                        type="submit"
                        variant="outlined"
                        color="secondary"
                        sx={{
                          textAlign: 'center',
                          fontFamily: 'Roboto',
                          fontSize: '16px',
                          marginTop: '15px',
                          fontWeight: '600',
                          lineHeight: 'normal',
                          textTransform: 'capitalize',
                          width: { lg: '10rem', sm: '8rem' },
                          height: '48px',
                          borderRadius: '6px',
                        }}
                        onClick={handleBackToCreateAICrafted}
                      >
                        {CommonLanguage.canclebtn}
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Grid>
            </Grid>
          </Grid>
        )}
        {showModal && <ErrorPage closeModal={closeModal} errormsg={errormsg} />}
        {sourceModal && <SegmentSourceError closeSource={closeSource} />}
      </Paper>
    </>
  );
};

export default CustomeCreateOffer;
